// ─── editableTemplatesRegistry.ts ───────────────────────────────────────────
// Unified registry mapping template IDs to their editable/clean build functions.

import {
  extractAllFields,
  buildEditableServiceContract, buildCleanServiceContract,
  buildEditableResume,          buildCleanResume,
  buildEditableNDA,             buildCleanNDA,
} from './editableTemplates';

import {
  buildEditableOfferLetter,     buildCleanOfferLetter,
  buildEditableChecklist,       buildCleanChecklist,
  buildEditableProposal,        buildCleanProposal,
  buildEditableFreelanceContract, buildCleanFreelanceContract,
} from './editableTemplates2';

import {
  buildEditableExpenseReport,   buildCleanExpenseReport,
  buildEditablePerformanceReview, buildCleanPerformanceReview,
  buildEditableSalesInvoice,    buildCleanSalesInvoice,
  buildEditableMeetingAgenda,   buildCleanMeetingAgenda,
} from './editableTemplates3';

import {
  buildEditableInvoiceHtml,
  extractInvoiceData,
  buildCleanInvoiceHtml,
} from './editableInvoice';

export interface TemplateEntry {
  buildEditable: () => string;
  extractData: (doc: Document) => Record<string, string>;
  buildClean: (data: Record<string, string>) => string;
}

export const TEMPLATE_REGISTRY: Record<string, TemplateEntry> = {
  '1':  { buildEditable: buildEditableInvoiceHtml,         extractData: extractInvoiceData,  buildClean: buildCleanInvoiceHtml },
  '2':  { buildEditable: buildEditableServiceContract,     extractData: extractAllFields,    buildClean: buildCleanServiceContract },
  '3':  { buildEditable: buildEditableResume,              extractData: extractAllFields,    buildClean: buildCleanResume },
  '4':  { buildEditable: buildEditableNDA,                 extractData: extractAllFields,    buildClean: buildCleanNDA },
  '5':  { buildEditable: buildEditableOfferLetter,         extractData: extractAllFields,    buildClean: buildCleanOfferLetter },
  '6':  { buildEditable: buildEditableChecklist,           extractData: extractAllFields,    buildClean: buildCleanChecklist },
  '7':  { buildEditable: buildEditableProposal,            extractData: extractAllFields,    buildClean: buildCleanProposal },
  '8':  { buildEditable: buildEditableFreelanceContract,   extractData: extractAllFields,    buildClean: buildCleanFreelanceContract },
  '9':  { buildEditable: buildEditableExpenseReport,       extractData: extractAllFields,    buildClean: buildCleanExpenseReport },
  '10': { buildEditable: buildEditablePerformanceReview,   extractData: extractAllFields,    buildClean: buildCleanPerformanceReview },
  '11': { buildEditable: buildEditableSalesInvoice,        extractData: extractAllFields,    buildClean: buildCleanSalesInvoice },
  '12': { buildEditable: buildEditableMeetingAgenda,       extractData: extractAllFields,    buildClean: buildCleanMeetingAgenda },
};
